import {createSelector} from 'reselect';
import { AppState } from './../../../store';
export const commonSelector = (state: AppState) => state.common;
export const stateSelector = (state) => state;
export const startDateSelector = createSelector(commonSelector, item => item.startDate || {
  date: new Date(),
  time: ''
});


export const endDateSelector = createSelector(commonSelector, item => item.endDate || {
  date: new Date(),
  time: ''
});
export const isUnificationFlowSelector = createSelector(commonSelector, item => item?.isUnificationFlow || 0);
export const tripTypeSelector = createSelector(commonSelector, item => item?.tripType || {
  name: 'ONE_WAY',
  rf: 'ow'
});

export const sourceSelector = createSelector(commonSelector, item => item.source || {});
export const destinationSelector = createSelector(commonSelector, item => item.destination || {});

export const previousSourceSelector = createSelector(commonSelector, item => item.previousSource || {});
export const previousDestinationSelector = createSelector(commonSelector, item => item.previousDestination || {});
export const multicityStopOversSelector = createSelector(commonSelector, item => item.stopOvers || []);
export const previousMulticityStopOversSelector = createSelector(commonSelector, item => item.previousStopOvers || []);
export const stopOversSelector = createSelector(commonSelector, item => item.stopOvers || []);
export const hrPackageSelector = createSelector(commonSelector, item => item?.package_id || "");
export const hrPackageTimeSelector = createSelector(commonSelector, item => item?.packageTime || "");
export const hrDefaultPackageSelector = createSelector(commonSelector, item => item?.defaultPackageId || "");
export const hrDefaultPackageTimeSelector = createSelector(commonSelector, item => item?.defaultPackageTime || "");
export const sourceLocusSelector = createSelector(commonSelector, item => item.source_locus || {});
export const destinationLocusSelector = createSelector(commonSelector, item => item.destination_locus || {});
export const gotribeSelector = createSelector(commonSelector, item => {
  const {gotribe = {} } = item;
  const { slots = {} } = gotribe?.data || {};
  const response = slots["gotribe_test"] || [];
  const newData = response?.filter((e) => e.banner_type === 10);
  return newData;
});
export const pageMakerSelector = createSelector(commonSelector, item => item.pageMakerResponse || {});
export const cabsFaqDataSelector = createSelector(commonSelector, item => item.faqData || []);
export const isSeoSelector = createSelector(commonSelector, item => item.isSeo || false);
export const metaDataSelector = createSelector(commonSelector, item => item.metaData || false); 
export const semFlowSelector = createSelector(commonSelector, item => item.sem_flow || false);
export const flowSelector = createSelector(commonSelector, item => item.flow || "direct-cabs");
export const semDataSelector = createSelector(commonSelector, (item) =>{ 
  return {
    sem_flow: item?.sem_flow || false,
    utm_medium:item?.utm_medium || '',
    utm_campaign: item?.utm_campaign|| ''
  }
});
export const queryCBSelector = createSelector(commonSelector, item => item?.showQueryCB || false);
export const homeHourlyRentalPackageSelector = createSelector(commonSelector, item => item?.hrPackageDetails || {})
export const osModalDetailsSelector = createSelector(commonSelector, item => item?.osModalDetails || {})
export const atModalDetailsSelector = createSelector(commonSelector, item => item?.atModalDetails || {})
export const oneWayCabSelector = createSelector(commonSelector, item => item?.isOneWayCab || false)
export const oneWayCabInterlinksSelector = createSelector(commonSelector, item => item?.oneway_interlinking_data || [])
export const cabsConfigDataSelector = createSelector(commonSelector, item => item?.configData?.feature_flags || {})
export const showRTRevampSelector = createSelector(commonSelector, item => item?.configData?.rt_revamp_web?.show_revamp_rt_dweb || false)
export const rtRevampSelector = createSelector(commonSelector, item => item?.configData?.rt_revamp_web?.cab_availability_text_dweb || "")
export const rtRevampLandingRTSelector = createSelector(commonSelector, item => item?.configData?.rt_revamp_web?.landing_return_time_text_dweb || "anytime till 09:45 PM")
export const rtRevampListingRTSelector = createSelector(commonSelector, item => item?.configData?.rt_revamp_web?.listing_return_time_text_dweb || "09:45 PM")
export const rtRevampToastTimeSelector = createSelector(commonSelector, item => item?.configData?.rt_revamp_web?.toast_open_time_dweb || 5000);
export const savaariBannerSelector = createSelector(commonSelector, item => item?.configData?.feature_flags?.savaari_banner_info || null);